import { useTranslation } from "react-i18next";
import type { FolderDetails } from "src/components/Folders/types";
import { useUpdateFolder } from "src/hooks/useFolders";

import { FolderModal } from "./FolderModal";

interface EditFolderModalProps {
	onClose: () => void;
	folderId: string;
	folderName?: string;
	folderColor?: string;
}

export const EditFolderModal = ({
	onClose,
	folderId,
	folderName,
	folderColor,
}: EditFolderModalProps) => {
	const { t } = useTranslation();
	const { mutateAsync: updateFolder, isPending: isLoading } = useUpdateFolder();

	const handleSubmit = async (name: string, details: FolderDetails | null) => {
		await updateFolder({ id: folderId, name, details });
	};

	return (
		<FolderModal
			onClose={onClose}
			onSubmit={handleSubmit}
			isLoading={isLoading}
			initialName={folderName}
			initialColor={folderColor}
			title={t("modals.editFolder.title", "Edytuj folder")}
			submitLabel={t("commands.save")}
		/>
	);
};
